import React from 'react'
import {
  TextField, SimpleShowLayout, ReferenceField, FunctionField
} from 'react-admin'
import { withStyles } from '@material-ui/core/styles'
import { formatHtml } from '../../../utils/getFields'
import SegmentVersion from '../segmentsType/header/SegmentVersion'
import SegmentWatch from '../SegmentWatch'
import ToolbarProvider from '../toolbarProvider/SegmentToolbarProvider'
import { dataProvider } from '../../../providers'
import SegmentCopy from '../SegmentCopy'
import moment from "moment";
import Comments from "../../../elements/comments";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import {Link} from 'react-router-dom'

const styles = {
  columnLeft: {
    '&:first-child': {
      paddingTop: '0',
      paddingLeft: '0'
    }
  },
  segmentView: {
    width: '327px'
  },
  formInputField: {
    padding: "10px 0",
    borderBottom: "1px dashed rgba(0, 0, 0, 0.38)"
  },
  title: {
    marginBottom: '5px'
  },
  subHeader: {
    color: '#777'
  },
  groupContent: {
    overflowX: 'auto',
    backgroundColor: '#f5f5f5',
    padding: '15px',
    marginBottom: '15px',

    '& del': {
      backgroundColor: 'rgb(254, 221, 222)'
    },

    '& ins': {
      backgroundColor: 'rgb(230, 254, 207)',
      textDecoration: 'none'
    }
  },
  flexGroup: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  textDanger: {
    color: '#b71c1c'
  },
  listDefault: {
    paddingLeft: '20px'
  }
}

const changesHover = (node) => {
  const user = node.getAttribute('data-username')
  const changeUser = node.getAttribute('data-changedata')
  if (user != undefined) {
    const action = node.tagName === 'INS' ? 'Добавил(-а)' : 'Удалил(а)'
    node.setAttribute('title', action + ' ' + (user ? user : changeUser))
  }
}

const CaseSegmentShow = ({ classes, record, permissions }) => (
  <>
    <SimpleShowLayout record={record} basePath="archive">
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div className={classes.flexGroup}>
          {record.statusId !== 2 ? (
              <>
                <h2 className={classes.title}>Версия сегмента {record.originalId}</h2>
                <div className={classes.subHeader}>
                  Изменён {moment(record.createdAt).format('LLL')}. {record.author.surname} {record.author.name}
                </div>
              </>
          ) : (
              <>
                <h2 className={classes.title}>Сегмент {record.id} (в архиве)</h2>
              </>
          )}
        </div>
        { record.cloneSegment && (
            <Card className={classes.card}>
              <CardContent>
                <Typography variant="title" className={classes.title}>Информация о сегменте</Typography>
                <Typography>
                  На основе текущего создан: <Link to={{pathname: `/segments/${record.cloneSegment.id}`}}>{ record.cloneSegment.id }</Link>
                </Typography>
              </CardContent>
            </Card>
        ) }
      </div>

      <ReferenceField
        reference="test-types"
        source="typeId"
        linkType={false}
        label="Вид"
      >
        <TextField class={classes.formInputField} source="name" />
      </ReferenceField>

      <div className={classes.flexGroup}>
        <section>
          <SimpleShowLayout
            record={record}
            basePath="/archive"
            className={classes.columnLeft}
          >
            <TextField
              source="case.module.name"
              label="Модуль"
            />
            <TextField
              className={classes.textDanger}
              source="reasonDeactivated"
              label="Причина архивации"
            />
            <TextField
              source="case.taskType.name"
              label="Вид задания"
            />
          </SimpleShowLayout>
        </section>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div className={classes.segmentView}>
            <SegmentVersion
              versions={record.versions}
              originalVersionId={record.originalId}
            />
          </div>
        </div>
      </div>
      <br />
      <div className={classes.groupContent}>
        <div><small className={classes.subHeader}>Задание</small></div>
        <div
          dangerouslySetInnerHTML={{
            __html: record.case.task.content
          }}
          onMouseMove={(event) => {changesHover(event.target)}}
        />
        <Comments id={record.case.task.id} idType="caseTaskId" showAddBlock={false} originalComment={true} />
      </div>
      {record.case.questions.map((question, i) => (
        <SimpleShowLayout record={record} basePath="archive">
          <div className={classes.groupContent}>
            <div><small className={classes.subHeader}>Подвопрос {i + 1}</small></div>
            <div
              dangerouslySetInnerHTML={{
                __html: question.content
              }}
              onMouseMove={(event) => {changesHover(event.target)}}
            />
            <Comments id={question.id} idType="caseQuestionId" entityForCase="null" showAddBlock={false} originalComment={true} />
            <hr /><br />

            <div><small className={classes.subHeader}>Ответ</small></div>
            <div
              dangerouslySetInnerHTML={{
                __html: question.answer
              }}
              onMouseMove={(event) => {changesHover(event.target)}}
            />
            <Comments id={question.id} idType="caseQuestionId" entityForCase="answer" showAddBlock={false} originalComment={true} />
            <hr /><br />

            <div className={classes.flexGroup}>
              <div>
                <p><small className={classes.subHeader}>Файлы для эксперта</small></p>
                <ul className={classes.listDefault}>
                  {question.expertAttaches.map((file) => (
                    <li>
                      <a href={file.url} target="_blank">{file.name}</a>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <p><small className={classes.subHeader}>Файлы для претендента</small></p>
                <ul className={classes.listDefault}>
                  {question.applicantAttaches.map((file) => (
                    <li>
                      <a href={file.url} target="_blank">{file.name}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <hr /><br />

            <div><small className={classes.subHeader}>Баллы</small></div>
            <div
              dangerouslySetInnerHTML={{
                __html: question.balls
              }}
              onMouseMove={(event) => {changesHover(event.target)}}
            />
          </div>
        </SimpleShowLayout>
      ))}
    </SimpleShowLayout>
    <div style={{ margin: 10 }}>
      <ToolbarProvider
        verifyStatus={record.verifyStatus}
        dataProvider={dataProvider}
        permissions={permissions}
        status={record.status}
        segmentId={record.id}
      />
    </div>
  </>
)

// @ts-ignore
export default withStyles(styles)(CaseSegmentShow)
